
const digest = 'd46e99bc0512423fb7234ba895052c1696d7debe3cd7768cc27004a03863588c';
const classes = {"formControl":"_formControl_njibp_1"};
const css = `._formControl_njibp_1 {
  margin-bottom: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  